import { UserService } from 'src/app/services/user-service/userservice';
import { DialogService } from 'src/app/services/dialog-service/dialog-service.service';
import { TrackingService } from './services/tracking-service/tracking.service';
import {
    Component,
    Inject,
    OnDestroy,
    OnInit,
    ChangeDetectorRef,
    PLATFORM_ID
} from '@angular/core';
import { NavigationStart, NavigationEnd, NavigationCancel, NavigationError, Router, RoutesRecognized } from '@angular/router';
import { UserInterface } from './model/user/user-interface';
import { ChangeDetectionStrategy } from '@angular/core';
import { DetectBrowserServiceService } from './services/detect-browser-service/detect-browser-service.service';
import { Observable, Subject } from 'rxjs';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { filter, map, shareReplay, takeUntil } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import Quill from 'quill';
import { isPlatformBrowser } from '@angular/common';
import { COOKIE_TIMOUT, TIMESTAMP_STRING } from '../environments/constants';
import { FeatbitService } from './services/featbit/featbit.service';
import { MarketplaceService } from './services/dataServices/marketplace-service/marketplace.service';

import { HealthService } from './services/health-service/health.service';
import { StripeService } from 'src/app/services/stripe-service/stripe.service';
import {
    getLocalStorageItem,
    getLocalStorageKeys,
    removeLocalStorageItem,
    setLocalStorageItem
} from 'src/app/utils/browser-storage';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
    title = 'SWARM-Application';
    public isIE: boolean;
    currentUser: UserInterface;
    public styles = {};
    private readonly isBrowser: boolean;
    private readonly skipCookieDialog: boolean;
    private readonly destroy$ = new Subject<void>();
    mobileSideMenuOpen = false;

    // Check flag value on init
    isComposerFlag: boolean;

    isHandset$: Observable<boolean> = this.breakpointObserver
        .observe(Breakpoints.Handset)
        .pipe(
            map((result) => result.matches),
            shareReplay()
        );

    constructor(
        private router: Router,
        private cd: ChangeDetectorRef,
        private breakpointObserver: BreakpointObserver,
        private detectbrowserservice: DetectBrowserServiceService,
        private trackingService: TrackingService,
        private dialogService: DialogService,
        private userService: UserService,
        private healthService: HealthService,
        private stripeService: StripeService,
        private marketplaceService: MarketplaceService,
        @Inject(PLATFORM_ID) platformId: object,
        private featbitService: FeatbitService,
    ) {
        this.isBrowser = isPlatformBrowser(platformId);
        this.skipCookieDialog = this.isGoogleCrawler();

        this.router.events.subscribe((event) => {
            if (event instanceof NavigationStart) { }
            else if (event instanceof RoutesRecognized) { }
            else if (event instanceof NavigationEnd) {
                this.updateRouteBodyClasses(event.urlAfterRedirects);
                this.cd.markForCheck();
            }
            else if (event instanceof NavigationCancel) { }
            else if (event instanceof NavigationError) { }
        });

        //Google Analytics
        if (!this.isBrowser) {
            return;
        }

        const trackingConsent = getLocalStorageItem('hasTrackingConsent');

        if (trackingConsent === null && !this.skipCookieDialog) {
            this.dialogService
                .openCookieConsentDialog(
                    'Cookie Consent',
                    'Cookies akzeptieren',
                    ' '
                )
                .subscribe((isConsentGiven) => {
                    if (isConsentGiven) {
                        setLocalStorageItem('hasTrackingConsent', 'true');
                        setLocalStorageItem(
                            'hasTrackingConsent' + TIMESTAMP_STRING,
                            new Date().toString()
                        );
                        if (this.currentUser != null) {
                            this.userService.setUserTrackingConsent(
                                this.currentUser.userName,
                                true
                            );
                        }

                        this.trackingService.initGoogleAnalytics();
                    } else {
                        setLocalStorageItem('hasTrackingConsent', 'false');
                        setLocalStorageItem(
                            'hasTrackingConsent' + TIMESTAMP_STRING,
                            new Date().toString()
                        );
                        //soll tracking verhindern. Wird evtl. nicht gebraucht, da auch an anderen stellen abgefragt wird
                        window['ga-disable-' + environment.GA_TRACKING_ID] =
                            true;
                    }
                });
        } else if (trackingConsent === null && this.skipCookieDialog) {
            window['ga-disable-' + environment.GA_TRACKING_ID] = true;
        } else if (trackingConsent === 'true') {
            this.trackingService.initGoogleAnalytics();
        } else {
            window['ga-disable-' + environment.GA_TRACKING_ID] = true;
        }
    }

    containsString(string) {
        return this.router.url.includes(string);
    }

    equalsString(string) {
        return this.router.url === string;
    }

    startsWithString(string) {
        return this.router.url.startsWith(string);
    }


    showSideMenu(): boolean {
        const path = this.router?.url
            ? this.router.url.split('?')[0].split('#')[0]
            : this.isBrowser
                ? window.location.pathname
                : '/';
        const segments = path.split('/').filter(Boolean);

        const isProductDetailExact =
            segments.length === 4 &&
            segments[0] === 'organisations' &&
            segments[2] === 'products' &&
            !!segments[1] &&
            !!segments[3];

        const isProductDetail =
            segments.length === 3 &&
            segments[0] === 'organisations' &&
            segments[2] === 'products' &&
            !!segments[1];

        const isProductSubpage =
            segments.length > 4 &&
            segments[0] === 'organisations' &&
            segments[2] === 'products'

        if (isProductDetailExact) return false;
        if (isProductDetail) return false;
        if (isProductSubpage) return false;

        return !(
            this.equalsString('/') ||
            this.startsWithString('/registry') ||
            this.startsWithString('/resendMail') ||
            this.equalsString('/organisation') ||
            this.containsString('/aboPayment') ||
            this.containsString('/firstProduct') ||
            this.startsWithString('/listing') ||
            this.equalsString('/home') ||
            this.startsWithString('/login') ||
            this.equalsString('/marktplatz') ||
            this.startsWithString('/marktplatz') ||
            this.startsWithString('/@') ||
            this.containsString('/resetPassword') ||
            this.containsString('/meineProdukte') ||
            this.startsWithString('/stoerungsuebersicht') ||
            this.startsWithString('/verify') ||
            this.startsWithString('/malfunction') ||
            this.startsWithString('/composer/template') ||
            this.startsWithString('/composer/instance') ||
            this.startsWithString('/impressum') ||
            this.equalsString('/impressum') ||
            this.equalsString('/privacy') ||
            this.containsString('/privacy') ||
            this.containsString('/agb') ||
            this.containsString('/tarife') ||
            this.containsString('/sitemap') ||
            this.startsWithString('/bautagebuch')
        );
    }


    /**
     * Checks if the current browser is any version of Internet Explorer.
     * If so, an error display page is shown,nthat IE is not supported for BIMSWARM.
     */
    checkIfIE() {
        this.isIE = this.isBrowser
            ? this.detectbrowserservice.areYouIE()
            : false;
    }

    ngOnInit() {
        this.checkIfIE();
        this.updateRouteBodyClasses(this.router.url);
        this.marketplaceService.toggle$
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => {
                this.mobileSideMenuOpen = !this.mobileSideMenuOpen;
                this.cd.markForCheck();
            });
        if (!this.isBrowser) {
            return;
        }

        for (const prop of getLocalStorageKeys()) {
            if (prop.includes(TIMESTAMP_STRING)) {
                const item = getLocalStorageItem(prop);
                const timestamp = Date.parse(item);
                const now = new Date();
                const diff = Math.abs(now.getTime() - timestamp);
                if (diff > COOKIE_TIMOUT) {
                    removeLocalStorageItem(prop);
                    removeLocalStorageItem(
                        prop.slice(0, -Math.abs(TIMESTAMP_STRING.length))
                    );
                }
            }
        }

    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    private updateRouteBodyClasses(url: string): void {
        const isBautagebuchRoute = (url || '').startsWith('/bautagebuch');
        const isWalletRoute = /^\/organisations\/[^/]+\/wallet(?:[/?#]|$)/.test(url || '');
        const body = document.body;
        const html = document.documentElement;

        body.classList.toggle('bautagebuch-route', isBautagebuchRoute);
        html.classList.toggle('bautagebuch-route', isBautagebuchRoute);
        body.classList.toggle('wallet-route', isWalletRoute);
    }

    private isGoogleCrawler(): boolean {
        if (!this.isBrowser || typeof navigator === 'undefined') {
            return false;
        }

        const userAgent = navigator.userAgent || '';
        return /Googlebot|AdsBot-Google|Mediapartners-Google|Storebot-Google|Google-InspectionTool/i.test(
            userAgent
        );
    }
}
